import {Component, computed, inject, input, linkedSignal, model, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CompteComptableService} from '../../../core/services/entities/compte-comptable.service';
import {CompteComptableDTO} from '../../../core/dtos/compte-comptable-dto';
import {ToastService} from '../../../core/services/technique/toast.service';
import {Auth2Service} from '../../../core/services/security/auth2.service';
import {SiteDTO} from '../../../core/dtos/site-dto';
import {MSG_KEY, MSG_SEVERITY} from '../../../core/constants';
import {ButtonThemeEnum} from '../../../shared/ui/button/button-theme-enum';
import {
  DxCheckBoxModule,
  DxNumberBoxModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTextBoxModule
} from 'devextreme-angular';
import {SharedModule} from '../../../shared/shared.module';

@Component({
  selector: 'yo-compte-comptable-dialog',
  templateUrl: './compte-comptable-dialog.component.html',
  styleUrls: ['./compte-comptable-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxNumberBoxModule,
    DxCheckBoxModule
  ]
})
export class CompteComptableDialogComponent {

  protected readonly ButtonThemeEnum = ButtonThemeEnum;

  private readonly compteComptableSvc = inject(CompteComptableService);
  private readonly toastSvc = inject(ToastService);
  private readonly auth2Svc = inject(Auth2Service);

  readonly displayDialog = model<boolean>(false);
  readonly dto = input<CompteComptableDTO | null>(null);
  readonly saved = output<{ dto: CompteComptableDTO; isUpdate: boolean }>();

  readonly dialogTitle = computed(() => this.dto()?.id
    ? 'Modification d\'un compte comptable'
    : 'Création d\'un compte comptable'
  );

  readonly formData = linkedSignal(() => {
    const dto = this.dto();
    return {
      id: dto?.id ?? 0,
      libelle: dto?.libelle ?? '',
      code: dto?.code ?? '',
      facture: dto?.facture ?? null,
      variationStock: dto?.variationStock ?? null,
      stock: dto?.stock ?? null,
      actif: dto?.actif ?? true,
      site: dto?.site ?? null
    };
  });

  readonly isFormValid = computed(() => {
    const d = this.formData();
    return !!d.site?.id
      && !!d.libelle?.trim() && d.libelle.length <= 100
      && !!d.code?.trim() && d.code.length <= 50;
  });

  findAllLocalSites = (): SiteDTO[] => this.auth2Svc.utilisateur.siteListLocaux;

  closeDialog = (): void => this.displayDialog.set(false);

  onChangeField = (field: string, value: any): void => {
    this.formData.update(s => ({...s, [field]: value}));
  };

  save = (): void => {
    if (!this.isFormValid()) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, 'Veuillez compléter le formulaire');
      return;
    }

    const payload = this.formData();
    const isUpdate = payload.id !== null && payload.id !== undefined && payload.id !== 0;

    this.compteComptableSvc.save(payload).subscribe(response => {
      this.saved.emit({dto: response.one, isUpdate});
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, 'Sauvegarde du compte comptable réalisée avec succès');
      this.closeDialog();
    });
  };
}
